(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  [0, 300, 1000].forEach(function(d) {
    setTimeout(function() {
      document.querySelectorAll('li[data-variant-id]').forEach(function(li) {
        var variantId = li.getAttribute('data-variant-id');
        if (!variantId) return;

        fetch('/variants/' + variantId + '.js')
          .then(function(r) { return r.json(); })
          .then(function(v) {
            if (!v.featured_image) return;
            var img = li.querySelector('img');
            if (img) {
              img.src = v.featured_image.src;
              img.srcset = '';
            }
          });
      });
    }, d);
  });

  } catch(e) { console.error(e); }
})();
})();
